import {
  formatJsonImgUrl,
  formatOldJson,
  updateDefaultValues,
  updateScenesAndHotspots,
  updateMenuItemsWithScene,
  updateItemId,
  updateFeatureMedia,
  checkEnableBranding,
} from './jsonHelper';
import { combineTour } from './tourHelper';
import { registerMissingScenes } from 'consts';
import { convertObjectKeys } from './urlHelper';

import applyOverrideData from 'assets/override-data';

const TOUR_DATA_URL = '/assets/tour.data.json';

const loadTourData = async () => {
  const response = await fetch(TOUR_DATA_URL);
  return response.json();
};

export const ensureData = (data) => {
  updateFeatureMedia(data);
  updateScenesAndHotspots(data);
  updateMenuItemsWithScene(data);
  updateItemId(data);
  updateDefaultValues(data);
  registerMissingScenes(data.scenes);
  return data;
};

var parsePreloadJsonScript = (jsonStr) => {
  const jsonStrFormatted = jsonStr
    .replace(/__OPEN_TAG__/g, '<')
    .replace(/__CLOSE_TAG__/g, '>');
  return JSON.parse(jsonStrFormatted);
};

export const loadTourJson = async (tourAccessCode) => {
  const data = {
    tour: null,
    json: null,
  };

  const preloadEl = document.getElementById('vizion-data');

  if (preloadEl) {
    data.json = ensureData(parsePreloadJsonScript(preloadEl.textContent));
    data.tour = combineTour(data.json.tour, data.json);
    data.tour = checkEnableBranding(data.tour);
    window.data = data;

    return Promise.resolve(data);
  }

  try {
    const { tour, json: rawJson } = await loadTourData();
    if (!tour?.id) return data;
    if (!tour.active) return { tour };

    const json = ensureData(
      formatOldJson(formatJsonImgUrl(TOUR_DATA_URL, convertObjectKeys(rawJson)))
    );

    applyOverrideData(json);

    json.tour.active = true;
    data.tour = combineTour(json.tour, json);
    data.tour = checkEnableBranding(data.tour, tour.subscriptionPlan);
    data.tour.subscriptionPlan = tour.subscriptionPlan;
    data.json = json;
  } catch (error) {
    console.log('loadTourJson.error', error);
  }
  window.data = data;
  console.log('window.data', data);
  return data;
};
